import { render } from "./ServersTable.vue?vue&type=template&id=4b2544c2&ts=true"
import script from "./ServersTable.vue?vue&type=script&lang=ts"
export * from "./ServersTable.vue?vue&type=script&lang=ts"

import "./ServersTable.vue?vue&type=style&index=0&id=4b2544c2&lang=css"

import exportComponent from "/home/runner/work/hotaru_theme/hotaru_theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__